import { Link } from "react-router-dom";
import { Button } from "../shared/button";
import List from "../shared/list";
import { IconEnvelope, IconTG } from "../icons";

export function Teacher() {
  return (
    <div className={"MainPageGrid"}>
      <div>
        <h2 style={{ textAlign: "left" }}>УРОКИ С ПРЕПОДАВАТЕЛЕМ</h2>
        <Link to={"/prices"}>
          <Button>Наши цены</Button>
        </Link>
        &nbsp;&nbsp;&nbsp;
        <Link
          to={
            "https://reviews.yandex.ru/ugcpub/object-digest?otype=Site&object=/site/bWluaW1hdGgyMzkucnU=&ranking=by_time&app_id=webmaster&utm_source=wm&disable_thermometer_rating_count=1&reviewsTypeId=0&isSiteService=1"
          }
          target="_blank"
        >
          <Button>Отзывы</Button>
        </Link>
        <div>
          <List
            pointerCircle={true}
            data={[
              "Обучение онлайн (Телемост, Zoom)",
              "Проходит с помощью виртуальной доски;",
              "Продолжительность урока 50 минут;",
              "Оплата происходит по счетам или пополнением Кошелька по реквизитам ИП Фефелова ОМ в Т-банк;",
              "Бесплатных пробных уроков нет.",
            ]}
          />
          <Link to={"/rules-short"}>
            <Button>
              <span>Правила проведения занятий</span>
            </Button>
          </Link>
          <h2 style={{ textAlign: "left" }}>НАШИ ПРОГРАММЫ</h2>
          <p>
            <ol>
              <li>
                Для дошкольников – 1-2 кл. программа по системе Эльконин-Давыдов
                (метрики, системы счислений) + Петерсон + олимпиадное
                направление.
              </li>

              <li>
                Для учеников 3-4 кл. подготовка к поступлению в 5й класс матшкол
                и ШГН.
              </li>

              <p>Программы для продолжающих.</p>
              <li>
                Ученикам 5 кл., кто не поступил и полностью не прошёл все темы –
                программа 3_4 подготовка к поступлению в 5й класс до конца.
              </li>

              <li>
                Ученикам 5-6 кл. олимпиадное направление – программа подготовки
                к матцентру и первый год матцентра.
              </li>

              <li>
                Ученикам 5, 6, 7, 8 кл. школьная программа + усиление –
                программа по учебнику ученика + задачникам матшколы.
              </li>

              <li>
                Ученикам 6, 7 кл. программа подготовка в матшколу 8й класс (239,
                30, физтех Капицы, ФТШ, Аничков Лицей)
              </li>

              <li>
                Ученикам 6, 7, 8 кл. олимпиадное направление – программа
                подготовка к ВСОШ.
              </li>

              <li>
                Для учеников 8 кл., программа подготовка в матшколу 9й класс
                (239, 30, физтех Капицы, ФТШ, Аничков Лицей)
              </li>

              <li>Ученики 9 кл. подготовка в ОГЭ</li>

              <li>Ученики 10-11 кл. подготовка к ЕГЭ</li>
            </ol>
          </p>
          <p>
            Для начала обучения <a href="/register">зарегистрируйтесь</a> на
            сайте тренажера и отправьте заявку на{" "}
            <a href="https://t.me/Fefelova_OM">@Fefelova_OM</a> или{" "}
            <a href="mailto:minimath239@yandex.ru">minimath239@yandex.ru</a> с
            ответами на следующие вопросы:
          </p>
          <List
            pointerCircle={true}
            data={[
              "Какие цели обучения?",
              "В каком классе учится ваш ребенок?",
              "В какую школу планируете поступать?",
              "Сколько раз в неделю планируете заниматься?",
              "В каких математических кружках учитесь или учились ранее?",
              "В какие дни и часы вам удобнее было бы заниматься?",
            ]}
          />

          <Link to={"/fefelova"}>
            <Button>
              <span> Далее</span>
            </Button>
          </Link>
        </div>
      </div>

      <img width="295" height="261" src={"/images/teacher1.svg"} alt="" />
    </div>
  );
}
